import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme';
import AppRoutes from './AppRoutes';

// The typewriter splash ("I have an idea.") used to run here before the hero.
// It held the first paint for four to five seconds on every first visit, which
// was most of the site's LCP, so the hero now plays its own entrance instead.
function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router future={{ v7_startTransition: true }}>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
